<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M9 11H6.5C5.67165 11 5.00012 11.6717 5 12.5V18.5C5 19.3284 5.67157 20 6.5 20H18.5C19.3284 20 20 19.3284 20 18.5V12.5C19.9999 11.6717 19.3284 11 18.5 11H16V10H18.5C19.8806 10 20.9999 11.1194 21 12.5V18.5C21 19.8807 19.8807 21 18.5 21H6.5C5.11929 21 4 19.8807 4 18.5V12.5C4.00012 11.1194 5.11936 10 6.5 10H9V11ZM16.8535 5.64648L16.1465 6.35352L13 3.20703V14H12V3.20703L8.85352 6.35352L8.14648 5.64648L12.5 1.29297L16.8535 5.64648Z"
      fill="currentColor"
    />
  </svg>
</template>
